import axios from 'axios';

import { RestrictionCode, RestrictionDetails } from '../interfaces/Restriction';
import { InvoicePaymentStatus } from '../interfaces/User';

/**
 * Reads the restriction a failed request was blocked by, or null if it was some other failure.
 *
 * Falls back to the pre-`details` shape of the overdue-invoice response (a bare `402` with a
 * top-level `invoicePaymentStatus`) so this dashboard works against an api-server on either side
 * of that change — which is why this build can be deployed before the server one.
 */
export const getRestriction = (error: unknown): RestrictionDetails | null => {
  if (!axios.isAxiosError(error)) return null;

  const data = error.response?.data as
    | { details?: RestrictionDetails; invoicePaymentStatus?: InvoicePaymentStatus }
    | undefined;

  if (data?.details?.code) return data.details;

  // Legacy: api-server before the restriction contract landed.
  if (error.response?.status === 402) {
    return {
      code: 'PAYMENT_OVERDUE',
      invoicePaymentStatus: data?.invoicePaymentStatus ?? null,
    };
  }

  return null;
};

export const isRestriction = (error: unknown, code: RestrictionCode): boolean =>
  getRestriction(error)?.code === code;
